import { baseApi } from "./baseApi";

const LOCAL_TRANSPORT_BASE_URL = "/local-transport";

export const localTransportApi = baseApi.injectEndpoints({
  tagTypes: ["LocalTransport"],
  endpoints: (build) => ({
    addLocalTransport: build.mutation({
      query: (body) => ({
        url: LOCAL_TRANSPORT_BASE_URL,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "LocalTransport", id: "LIST" }],
    }),

    listLocalTransport: build.query({
      query: (params) => ({
        url: LOCAL_TRANSPORT_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "LocalTransport",
                id: _id,
              })),
              { type: "LocalTransport", id: "LIST" },
            ]
          : [{ type: "LocalTransport", id: "LIST" }],
    }),

    getLocalTransportDetail: build.query({
      query: (id) => `${LOCAL_TRANSPORT_BASE_URL}/${id}`,
      providesTags: (result, error, { _id }) => [
        { type: "LocalTransport", id: _id },
        { type: "LocalTransport", id: "LIST" },
      ],
    }),

    updateLocalTransport: build.mutation({
      query: ({ _id, ...body }) => ({
        url: `${LOCAL_TRANSPORT_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { _id: id }) => [
        { type: "LocalTransport", id },
        { type: "LocalTransport", id: "LIST" },
      ],
    }),

    approveLocalTransport: build.mutation({
      query: ({ _id, status }) => ({
        url: `${LOCAL_TRANSPORT_BASE_URL}/${_id}/approve`,
        method: "PUT",
        body: { status },
      }),
      invalidatesTags: (result, error, { _id }) => [
        { type: "LocalTransport", id: _id },
        { type: "LocalTransport", id: "LIST" },
      ],
    }),

    getDDLLocalTransportList: build.query({
      query: (params) => ({
        url: `${LOCAL_TRANSPORT_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({
                type: "LocalTransport",
                _id,
              })),
              { type: "LocalTransport", id: "DDL" },
            ]
          : [{ type: "LocalTransport", id: "DDL" }],
    }),
    listShipmentsByLocalTransportId: build.query({
      query: ({ id, page, limit }) => ({
        url: `${LOCAL_TRANSPORT_BASE_URL}/${id}/shipments`,
        params: { page, limit },
      }),
      providesTags: (_result, _error, { id }) => [
        { type: "LocalTransport", id: id },
        { type: "LocalTransport", id: "LIST" },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useAddLocalTransportMutation,
  useListLocalTransportQuery,
  useLazyListLocalTransportQuery,
  useGetLocalTransportDetailQuery,
  useUpdateLocalTransportMutation,
  useApproveLocalTransportMutation,
  useLazyGetDDLLocalTransportListQuery,
  useGetDDLLocalTransportListQuery,
  useListShipmentsByLocalTransportIdQuery,
  useLazyListShipmentsByLocalTransportIdQuery,
} = localTransportApi;
